export default __webpack_public_path__ + "static/media/duo-violino-e-piano.096499fa.mp3";